import { c as _c } from "react/compiler-runtime";
import { Accordion, AccordionControl, AccordionItem, AccordionPanel } from "@mantine/core";
import PureHtml from "@/components/custom/PureHtml";
export default function HomeFaqs(t0) {
  const $ = _c(14);
  const {
    afaqs
  } = t0;
  let t1;
  if ($[0] !== afaqs?.faqs) {
    t1 = afaqs?.faqs || [];
    $[0] = afaqs?.faqs;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hfaqs = t1;
  const t2 = afaqs?.heading || "Frequently Asked Questions";
  let t3;
  if ($[2] !== t2) {
    t3 = <h2 className="text-xl lg:text-2xl">{t2}</h2>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = afaqs?.subtext;
  let t5;
  if ($[4] !== t4) {
    t5 = <PureHtml html={t4} />;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== hfaqs) {
    t6 = hfaqs?.map(_temp);
    $[6] = hfaqs;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t6) {
    t7 = <div className="bg-white rounded p-2 shadow"><div className="grid grid-cols-1 lg:grid-cols-2 gap-2">{t6}</div></div>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t3 || $[11] !== t5 || $[12] !== t7) {
    t8 = <section className="section-faqs py-2 lg:py-3" id="faqs"><div className="max-w-7xl mx-auto px-2">{t3}{t5}{t7}</div></section>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}
function _temp(hfaq, index) {
  return <Accordion key={index} variant="separated" transitionDuration={1000} className="w-full" chevronIconSize={24}><AccordionItem value={hfaq.question}><AccordionControl aria-label={hfaq.question} bg="gray.1" className="rounded-t-sm"><h3 className="text-base mb-0">{hfaq.question}</h3></AccordionControl><AccordionPanel><PureHtml html={hfaq.answer} /></AccordionPanel></AccordionItem></Accordion>;
}